import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type TranscriptTurnsFetchFailedAction = {
	type: 'TRANSCRIPT_TURNS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): TranscriptTurnsFetchFailedAction => ({
	type: 'TRANSCRIPT_TURNS_FETCH_FAILED',
	payload,
});
